/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'fabric.editor.chromeCollapsedPlaceholder': 'Digite algo…',
  'fabric.editor.editorAssistiveLabel': 'Área de conteúdo principal, comece a digitar para inserir texto.',
  'fabric.editor.headingLink.toolbarHelpTitle': 'Abrir diálogo de ajuda',
};
